import SvgLogo from './logo-textless.svg?svgr';

function LogoNavbar({ children }: { children?: React.ReactNode }) {
  return (
    <nav className="top-0 left-0 right-0 z-10 bg-white dark:bg-[#153154] dark:text-white flex px-6 py-5">
      <SvgLogo />
      {children}
    </nav>
  );
}

export default LogoNavbar;
